// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kingambit: PokeData = {
  "id": 983,
  "name": "kingambit",
  "height": 20,
  "weight": 1200,
  "base_experience": 275,
  "types": [
    PokeType.DARK,
    PokeType.STEEL
  ],
  "api_moves": [
    "scratch",
    "guillotine",
    "swords-dance",
    "leer",
    "slash",
    "scary-face",
    "fury-cutter",
    "metal-claw",
    "torment",
    "metal-sound",
    "iron-defense",
    "metal-burst",
    "assurance",
    "night-slash",
    "iron-head",
    "retaliate",
    "kowtow-cleave"
  ],
  "moves": [
    "scratch",
    "leer",
    "scary-face",
    "metal-claw",
    "metal-sound",
    "iron-defense",
    "metal-burst",
    "night-slash",
    "dark-bargain",
    "smart-strike",
    "metal-rush",
    "magnet-bomb",
    "lash-out"
  ],
  "evolution_chain": {
    "id": 317,
    "item": null,
    "species": [
      {
        "name": "pawniard",
        "order": 625,
        "types": [
          PokeType.DARK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bisharp",
        "order": 626,
        "types": [
          PokeType.DARK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 624,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 52,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "kingambit",
        "order": 1008,
        "types": [
          PokeType.DARK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 625,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 141,
    "speed": 70,
    "ability_power": 189
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
